<template>
  <div>
    <Snackbar />
    <slot />
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n();
const { setHotels } = useHotels();

const { data } = await useFetch<PropertyHotel[]>("/api/v2/properties/hotels", {
  query: { locale },
});
setHotels(data);

useHead({
  htmlAttrs: {
    lang: locale.value,
  },
});
definePageMeta({
  middleware: [() => setResponseStatus(404)],
});
</script>
